export class Bank<T> {
  readonly bank: T[];
  currentIndex: number = 0;

  constructor(bank: T[]) {
    this.bank = bank;
  }

  /**
   * Get the next object in our bank, cycling around if necessary.
   * @returns {T} The next object.
   */
  getNextObject() {
    if (this.isExhaused()) {
      console.debug("Exhausted bank was", this.bank);
      throw new Error(`Accessing next item in an already exhausted bank!`);
    }

    return this.bank[this.currentIndex++];
  }

  isExhaused() {
    return this.currentIndex >= this.bank.length;
  }

  isEmpty() {
    return this.bank.length == 0;
  }
}

/**
 * Manage a bank of items, grabbing items sequentially and cycling back around when necessary.
 * Also supports applying the bank of items to another object array by adding the values from the bank as a specified field.
 */
export class CyclingBank<T> extends Bank<T> {
  constructor(bank: T[]) {
    super(bank);
  }

  /**
   * Get the next object in our bank, cycling around if necessary.
   * @returns {T} The next object.
   */
  getNextObject() {
    return this.bank[this.currentIndex++ % this.bank.length];
  }
}
